import { BASE_URL } from "../constants/app";
export const getImageProduct =(imageName)=>{
    return `${BASE_URL}/asset/uploads/images/${imageName}`;//o may co quan
                                                     //o lop: /assets/uploads/products/
}                                                   //upload lên render: asset/uploads/images
export const getImageSliders =(imageName)=>{
    return `${BASE_URL}/asset/uploads/images/sliders/${imageName}`;
                                                     //o lop: /assets/uploads/images/sliders
}
export const getImageBanners =(imageName)=>{
    return `${BASE_URL}/asset/uploads/images/banners/${imageName}`;
}